import { ErrorCode } from "src/constants/errorCodes";
import { GLP1_REFILL_QUESTIONNAIRE_ID } from "src/constants/misc";
import { PlanCompleted } from "src/constants/icons";
import { TranslationKey } from "src/types/translationKey";
import { Button } from "@9amhealth/shared";
import { ComponentProps } from "react";

type ButtonProps = ComponentProps<typeof Button>;

export interface ErrorStateConfig {
  icon?: React.ComponentType<{ size: number }>;
  title: TranslationKey;
  description: TranslationKey;
  buttonText: TranslationKey;
  buttonTheme: ButtonProps["theme"];
  navigateTo: string;
  hideArrow?: ButtonProps["hideArrow"];
  showContactInfo?: boolean;
}

export const SPECIFIC_ERROR_CONFIGS: Record<string, ErrorStateConfig> = {
  [`session_${GLP1_REFILL_QUESTIONNAIRE_ID}_${ErrorCode.questionnaireSessionNotAvailable}`]:
    {
      icon: PlanCompleted,
      title: "error_code",
      description: "help.messageCareTeam",
      buttonText: "close",
      buttonTheme: "sunrise",
      navigateTo: "/app/chat",
      hideArrow: false
    }
};

export const DEFAULT_ERROR_CONFIG: ErrorStateConfig = {
  title: "error_code",
  description: "help.contactUs",
  buttonText: "close",
  buttonTheme: "charcoal",
  navigateTo: "/app/chat",
  hideArrow: true,
  showContactInfo: true
};

export const getErrorConfig = (error: string): ErrorStateConfig => {
  if (!error) {
    return DEFAULT_ERROR_CONFIG;
  }

  const specificConfig = SPECIFIC_ERROR_CONFIGS[error] as
    | ErrorStateConfig
    | undefined;

  if (specificConfig) {
    return specificConfig;
  }

  return DEFAULT_ERROR_CONFIG;
};
